import Flickity from 'flickity';
import '../../../../../node_modules/flickity/css/flickity.css';
import $ from 'jquery';

$(() => {

	$('.benefits__items').each((index, el) => {
		const slider = new Flickity(el, {
			pageDots: false,
			cellAlign: 'center',
			prevNextButtons: false,
			watchCSS: true
		});
	});

});